import "/src/style/main.scss"

import AOS from 'aos';
AOS.init({
    offset: 100,
    duration: 600,
    delay: 100,
    once: true,
});

// Other
import "./functions";

// Modules
import SiteHeader from "./modules/site-header";
SiteHeader().init()

import SiteNavMobile from "./modules/site-nav-mobile";
SiteNavMobile().init()

import Slider from "./modules/slider";
Slider().init()

import HandDrawnCircle from "./modules/hand-drawn-circle";
HandDrawnCircle().init()

// Templates

// Template parts

// Pages

